export const slides = [

    {
        src:"Dibujos/etudeSanguine.jpg",
        title: "Étude Sanguine",
        description:"sanguine sur papier, 45 x 35 cm, 2025",
        price: "380€"
    },
    {
        src:"Dibujos/Gradiva.jpg",
        framedSrc:"Dibujos/Gradiva_framed.jpg",
        title: "Gradiva",
        description: "pastel blanc sur papier bleu, 43 x 36 cm, 2026",
        price: "350€",
        framed: true
    },
    {
        src:"Dibujos/Mnemos_extended.jpg",
        framedSrc:"Dibujos/Mnemosyne_framed.jpeg",
        title: "Mnemosyne",
        description: "fusain et crayon sur papier, 122 x 90 cm, 2025",
        price: "1,200€",
        framed: true
    },
    {
        src:"Dibujos/Ninfa.jpg",
        framedSrc:"Dibujos/Ninfa_framed.jpeg",
        title: "Ninfa",
        description: "fusain sur papier, 107 x 90 cm, 2026",
        price: "1,300€",
        framed: true
    },
    {
        src:"Dibujos/Ninfa2.jpg",
        title: "Ninfa II",
        description: "fusain sur papier, 92 x 121 cm, 2026",
        price: "900€"
    },
    {
        src:"Dibujos/penseur.jpg",
        title: "Penseur",
        description: "crayon sur papier, 30 x 20 cm, 2025",
        price: "150€"
    },
    {
        src:"Dibujos/atlas.jpg",
        title: "Atlas",
        description: "crayon sur papier, 30 x 20 cm, 2025",
        price: "150€"
    },
    {
        src:"Dibujos/homme-escargot.jpg",
        title: "L'Homme Escargot",
        description: "fusain sur papier, 140 x 115 cm, 2026",
        price: "1100€"
    },
    {
        src:"Dibujos/PourSoi.jpg",
        framedSrc:"Dibujos/pour-soi_framed.png",
        title: "Pour soi",
        description: "sanguine sur papier, 45 x 35 cm, 2026",
        price: "480€",
        framed: true
    },
    {
        src:"Dibujos/EnSoi3.jpg",
        title: "En soi III",
        description: "fusain sur papier, 43.2 x 35.6 cm, 2026",
        price: "VENDU"
    },
    {
        src:"Dibujos/Refuge.jpg",
        title: "Refuge",
        description:"crayon sur papier, 100 x 80 cm, 2026",
        price: "900€"
    },
    {
        src:"Dibujos/EtudeModele.jpeg",
        title: "Femme Agenouillée",
        description:"fusain sur papier, 100 x 90 cm, 2026",
        price: "800€"
    },
    {
        src:"Dibujos/ChevalNoir.jpg",
        title: "Cheval et Homme",
        description:"pastel blanc sur papier noir, 70 x 50 cm, 2026",
        price: "300€"
    },
    {
        src:"Dibujos/En-Soi2.jpg",
        title: "En-soi",
        description:"42 x 56 cm, 2026",
        price: "420€"
    },
    {
        src:"Dibujos/etudeBleu.jpg",
        title: "Étude Bleue",
        description:"pastel blanc sur papier bleu, 60 x 50 cm, 2026",
        price: "450€"
    },
    {
        src:"Dibujos/etudeNoir.jpg",
        title: "Étude Noir",
        description:"pastel blanc sur papier noir, 42 x 30 cm, 2026",
        price: "400€"
    },
    {
        src:"Dibujos/EtudeBrun.jpg",
        title: "Étude Brun",
        description:"pierre noire sur papier brun, 40 x 30 cm, 2026",
        price: "380€"
    },
    {
        src:"Dibujos/PourSoi-lll.jpg",
        title: "Pour-soi III",
        description:"sanguinesur papier, 45 x 35 cm, 2026",
        price: "380€"
    },
    {
        src:"Dibujos/IMG_0203.jpg",
        title: "Ménade",
        description:"crayon sur papier, 25 x 38 cm, 2024"
    },
    {
        src:"Dibujos/ensoi2.jpg",
        title: "En soi",
        description:"pierre noire sur papier, 43.2 x 35.6 cm, 2024"
    },
    {
        src:"Dibujos/Thanatos.jpg",
        title: "Thanatos",
        description: " crayon sur papier, 45 x 35 cm, 2024"
    }


];

